import type { LDClient } from 'launchdarkly-vue-client-sdk'

/**
 * Module-level reference to the LaunchDarkly client instance.
 *
 * This exists so the LD client can be accessed outside of Vue component context
 * (e.g. in router guards), where useLDFlag/useLDReady/useLDClient cannot be used
 * because they rely on Vue's inject() API.
 *
 * Must be set during app initialization in main.ts before the router is used.
 */
let _ldClient: LDClient | undefined

export function setLdClient(client: LDClient): void {
  _ldClient = client
}

export function getLdClient(): LDClient | undefined {
  return _ldClient
}

/**
 * Waits for the LaunchDarkly client to finish initializing.
 * Polls up to timeoutMs (default 2000ms) before resolving regardless.
 * Safe to call outside of Vue component context.
 */
export async function waitForLdReady(timeoutMs = 2000): Promise<void> {
  const client = _ldClient

  if (!client) {
    return
  }


  await Promise.race([
    client.waitUntilReady(),
    new Promise<void>((resolve) => setTimeout(resolve, timeoutMs))
  ])
}

